<template>
  <div class="chart-data-tile" :class="{ 'is-leading-tile' : isLeadingTile }">
    <div>
      <animated-number :value="value" unit="%" class="value" />
      <percentage-bar :percentage="value" :color="dataChartColor" />
    </div>
    <div>
      <p v-if="label" class="label" v-html="label"></p>
    </div>
  </div>
</template>

<script>
import PercentageBar from './PercentageBar'
import AnimatedNumber from './AnimatedNumber'
import appConfig from '../app-config.json'

export default {
  name: 'chart-data-tile',
  components: { PercentageBar, AnimatedNumber },
  props: {
    value: {
      type: Number,
      required: true
    },
    label: {
      type: String
    },
    isLeadingTile: {
      type: Boolean,
      default: false
    },
    themeColor: {
      type: String,
      default: 'primary',
      validator: value => {
        return appConfig.themeColors.hasOwnProperty(value)
      }
    }
  },
  data () {
    return {
      dataChartColor: appConfig.themeColors[this.themeColor]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/variables';

  .chart-data-tile {
    padding: 10px;
    color: white;
  }

  .value {
    font-family: 'EffraHeavy';
    font-size: 25px;
    line-height: 1;
    display: inline-block;
    margin-bottom: 5px;
  }

  .label {
    font-family: 'Effra';
    font-size: 12px;
    line-height: 1.2;
  }

  .chart-data-tile {

    &.is-leading-tile {
      display: flex;
      background: darken($brand-secondary, 5%);
      justify-content: space-between;
      margin-bottom: 15px;

      & > * {
        width: 48%;
      }

      .value {
        font-size: 35px;
      }

      .label {
        font-weight: 500;
        font-size: 13px;
        margin: 0;
        text-transform: uppercase;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ChartDataTile.vue